<template>
    <div>
        <dx-grid
            url="transactions"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="deleteTransactionsDialog" max-width="400">
            <v-card class="pa-3">
                <div class="headline text-warning mb-2">Are you sure</div>

                <div class="mb-3">
                    This will delete the {{ selected.length }} selected
                    transactions
                </div>

                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeDeleteTransactionDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="deleteTransactions"
                        :loading="processing"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency, toISOLocal } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Transactions",

        selected: [],
        actions: [],

        processing: false,

        deleteTransactionsDialog: false,

        columns: [
            {
                field: "type",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    switch (value) {
                        case "Debit":
                        case "Credit":
                            return "mdi-currency-usd";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    switch (value) {
                        case "Debit":
                            return "success";
                        case "Credit":
                            return "rgb(243, 81, 35)";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Description",
                field: "description",
                visible: true,
                filterValues: [],
                filterValue: "",
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                visible: true,
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Year",
                field: "year",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.actions.push({
            text: "Delete",
            action: this.openDeleteTransactionsDialog,
            showOnSelection: true,
        });
    },
    methods: {
        async onRowClicked(row) {
            // this.$router.push({
            //     name: "Account View",
            //     params: {
            //         id: row.accountID,
            //     },
            //     query: {
            //         paymentPickupID: row.id,
            //     },
            // });
        },
        openDeleteTransactionsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteTransactionsDialog = true;
        },
        closeDeleteTransactionDialog() {
            this.deleteTransactionsDialog = false;
        },
        async deleteTransactions() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/transactions/delete?",
                    this.selected.map((s) => s.id)
                );

                this.processing = false;
                this.deleteTransactionsDialog = false;

                this.$refs.grid.reloadGrid();
                this.$refs.grid.clearSelection();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
